import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Col, Row, Section } from 'components/grid'
import { P } from 'components/typography/Paragraph'
import React from 'react'

export default function Decodables() {
	return (
		<Section margin="mt-20" className="scroll-mt-14">
			<SectionTitle
				title="Decodable Text Anthologies"
				text={[
					<span key={Math.random()}>
						ARC's Decodable Text Anthologies feature highly engaging, content-rich books that provide an additional layer of reading practice. Every text is controlled
						for the specific Unit, Weekly, and Daily focus grade-level Foundational Skills that are taught and practiced in ARC Core.
						<br></br>
						<span className="text-xs">Select Decodable Text Anthologies Available Below.</span>
					</span>
				]}
			/>
			<Row center>
				<Col width="w-1/3 md:w-1/4">
					<Resource protected title="Decodable Text Anthology | Grade K | Unit 2 | Student" text="Grade K Unit 2 | Student Copy" />
				</Col>
				<Col width="w-1/3 md:w-1/4">
					<Resource protected title="Decodable Text Anthology | Grade 1 | Unit 1 | Student" text="Grade 1 Unit 1 | Student Copy" />
				</Col>
				<Col width="w-1/3 md:w-1/4">
					<Resource protected title="Decodable Text Anthology | Grade 1 | Unit 2 | Student" text="Grade 1 Unit 2 | Student Copy" />
				</Col>
			</Row>
			<P className="mt-6 text-center">For additional details on ARC's Decodable Text Anthologies and the Digital Teacher Guide see below</P>
			<Row center>
				<Col width="w-1/3">
					<Resource title="Decodables Slick | No Pricing" />
				</Col>
			</Row>
		</Section>
	)
}
